import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import isRTL from '@adsk/bim360-matrix-react-helpers/es/isRTL';

import './_SingleLineEditor.scss';

export default class SingleLineEditor extends PureComponent {
  constructor(props) {
    super(props);

    this._setInputRef = this._setInputRef.bind(this);
    this._handleOnKeyDown = this._handleOnKeyDown.bind(this);
    this._handleOnChange = this._handleOnChange.bind(this);

    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.select = this.select.bind(this);
  }

  focus() {
    this.inputRef && this.inputRef.focus();
  }

  blur() {
    this.inputRef && this.inputRef.blur();
  }

  select() {
    this.inputRef && this.inputRef.select();
  }

  _setInputRef(inputRef) {
    this.inputRef = inputRef;
  }

  _handleOnChange(e) {
    return this.props.onChange(
      EditorState.createWithContent(ContentState.createFromText(e.target.value))
    );
  }

  _handleOnKeyDown(e) {
    switch (e.keyCode) {
      case 27:
        this.props.onEscape && this.props.onEscape(e);
        break;
      case 13:
        this.props.handleReturn && this.props.handleReturn(e);
        break;
      default:
        break;
    }
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      editorState,
      classname,
      onChange,
      handleReturn,
      handlePastedText,
      stripPastedStyles,
      onEscape,
      ...rest
    } = this.props;
    /* eslint-enable no-unused-vars */

    const value = convertToRaw(editorState.getCurrentContent())
      .blocks.map(_ => _.text)
      .join('\n');
    const classes = classnames(classname, { 'SingleLineEditor--rtl': isRTL(value) });
    return (
      <input
        {...rest}
        className={classes}
        ref={this._setInputRef}
        value={value}
        type="text"
        onKeyDown={this._handleOnKeyDown}
        onChange={this._handleOnChange}
      />
    );
  }
}

SingleLineEditor.propTypes = {
  editorState: PropTypes.object,
  handlePastedText: PropTypes.func,
  stripPastedStyles: PropTypes.bool,
  onChange: PropTypes.func,
  handleReturn: PropTypes.func,
  onEscape: PropTypes.func,
  classname: PropTypes.string
};
